var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE6\x8B\x96\xE5\x8A\xA8 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.99997 1.75002H9.09122V3.84127H6.99997V1.75002ZM11.753 1.75002H13.8442V3.84127H11.753V1.75002ZM6.99997 6.69376H9.09122V8.78501H6.99997V6.69376ZM11.753 6.69376H13.8442V8.78501H11.753V6.69376ZM6.99997 11.6358H9.09122V13.727H6.99997V11.6358ZM11.753 11.6358H13.8442V13.727H11.753V11.6358ZM6.99997 16.5804H9.09122V18.6716H6.99997V16.5804ZM11.753 16.5804H13.8442V18.6716H11.753V16.5804Z",
    fill: "#C0C0C0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/拖动.cf08cdeff71220dced02c97558db24b6.svg";
export { ForwardRef as ReactComponent };